import React, { useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { Box, Button, MobileStepper } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Flex } from 'reflexbox';
import Skeleton from '@mui/material/Skeleton';
import {useImageLoad} from '../../helpers/helpers';

const CarouselSlide = ({ src, idx, height }) => {
    const { imgRef, loaded, error, onLoad, onError, showSkeleton } = useImageLoad(src);

    return (
        <Box position="relative">
            {showSkeleton && (
                <Skeleton variant="rect" width="100%" height={height} animation="wave" />
            )}
            <img
                ref={imgRef}
                src={src}
                alt={`image-${idx}`}
                onLoad={onLoad}
                onError={onError}
                style={{
                    width: '100%',
                    height,
                    objectFit: 'cover',
                    display: 'block',
                    opacity: loaded || error ? 1 : 0,
                    position: showSkeleton ? 'absolute' : 'static',
                    top: showSkeleton ? 0 : undefined,
                    left: showSkeleton ? 0 : undefined,
                }}
            />
        </Box>
    );
};

const SwipeableImage = ({
    images,
    height = 200,
    showNav = true,
    showNavArrows = true,
    overlayNavOnImage = true,
}) => {
    const [activeStep, setActiveStep] = useState(0);

    const handleNext = () => {
        setActiveStep((prev) => Math.min(prev + 1, images.length - 1));
    };

    const handleBack = () => {
        setActiveStep((prev) => Math.max(prev - 1, 0));
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    return (
        <Box position="relative" style={{ overflow: 'hidden' }}>
            <SwipeableViews
                axis="x"
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
            >
                {images.map((src, idx) => (
                    <CarouselSlide key={src} src={src} idx={idx} height={height} />
                ))}
            </SwipeableViews>

            {showNav && (
                <MobileStepper
                    steps={images.length}
                    position="static"
                    variant="dots"
                    activeStep={activeStep}
                    style={{
                        background: 'transparent',
                        justifyContent: 'center',
                        padding: overlayNavOnImage ? 8 : '8px 0',
                        position: overlayNavOnImage ? 'absolute' : 'relative',
                        bottom: overlayNavOnImage ? 0 : 'unset',
                        width: '100%',
                    }}
                    nextButton={
                        showNavArrows && (
                            <Flex style={{ width: '100%', justifyContent: 'flex-end', paddingRight: '8px' }}>
                                <Button
                                    size="small"
                                    onClick={handleNext}
                                    disabled={activeStep === images.length - 1}
                                    style={{ backgroundColor: '#00000075', color: 'white', minWidth: '32px' }}
                                >
                                    <KeyboardArrowRight />
                                </Button>
                            </Flex>
                        )
                    }
                    backButton={
                        showNavArrows && (
                            <Flex style={{ width: '100%', paddingLeft: '8px' }}>
                                <Button
                                    size="small"
                                    onClick={handleBack}
                                    disabled={activeStep === 0}
                                    style={{ backgroundColor: '#00000075', color: 'white', minWidth: '32px' }}
                                >
                                    <KeyboardArrowLeft />
                                </Button>
                            </Flex>
                        )
                    }
                />
            )}
        </Box>
    );
};

export default SwipeableImage;
